import type {PerkIntegrationSpec, PerkIntegrationStruct} from '@cohort/shared/apps/app';
import {z} from 'zod';

const TalonOneCouponConfigSchema = z.object({
  campaignId: z.number().min(1, {message: 'errorRequired'}),
  usageLimit: z.number().min(0, {message: 'errorRequired'}),
  storeUrl: z.string().url({message: 'errorInvalidUrl'}),
});
export type TalonOneCouponConfig = z.infer<typeof TalonOneCouponConfigSchema>;

const TalonOneCouponStateSchema = z.object({});
export type TalonOneCouponState = z.infer<typeof TalonOneCouponStateSchema>;

export const ActivatedTalonOneCouponAccessDataSchema = z.object({
  couponId: z.number().int().positive(),
  couponCode: z.string(),
});
export type ActivatedTalonOneCouponAccessData = z.infer<
  typeof ActivatedTalonOneCouponAccessDataSchema
>;

export const TalonOneCouponAccessDataSchema = z.union([
  ActivatedTalonOneCouponAccessDataSchema,
  z.object({}),
]);
export type TalonOneCouponAccessData = z.infer<typeof TalonOneCouponAccessDataSchema>;

const TalonOneCouponUsageInputSchema = z.object({});
export type TalonOneCouponUsageInput = z.infer<typeof TalonOneCouponUsageInputSchema>;

const TalonOneCouponUsageDataSchema = z.object({
  couponId: z.number().int().positive(),
  couponCode: z.string(),
});
export type TalonOneCouponUsageData = z.infer<typeof TalonOneCouponUsageDataSchema>;

const TalonOneCouponExposedUsageDataSchema = z.object({});
export type TalonOneCouponExposedUsageData = z.infer<typeof TalonOneCouponExposedUsageDataSchema>;

const TalonOneCouponExposedUsageDataForExportSchema = TalonOneCouponExposedUsageDataSchema;
export type TalonOneCouponExposedUsageDataForExport = z.infer<
  typeof TalonOneCouponExposedUsageDataForExportSchema
>;

export const TalonOneCouponExposedConfigSchema = TalonOneCouponConfigSchema;
export type TalonOneCouponExposedConfig = z.infer<typeof TalonOneCouponExposedConfigSchema>;

export type TalonOneCouponPerkIntegrationStruct = PerkIntegrationStruct<
  'talon-one.coupon',
  TalonOneCouponConfig,
  TalonOneCouponExposedConfig,
  TalonOneCouponState,
  TalonOneCouponAccessData,
  TalonOneCouponUsageInput,
  TalonOneCouponUsageData,
  TalonOneCouponExposedUsageData,
  TalonOneCouponExposedUsageDataForExport
>;
export const TalonOneCouponPerkIntegrationSpec: PerkIntegrationSpec<TalonOneCouponPerkIntegrationStruct> =
  {
    id: 'talon-one.coupon' as const,
    configSchema: TalonOneCouponConfigSchema,
    exposedConfigSchema: TalonOneCouponExposedConfigSchema,
    stateSchema: TalonOneCouponStateSchema,
    accessDataSchema: TalonOneCouponAccessDataSchema,
    usageInputDataSchema: TalonOneCouponUsageInputSchema,
    internalUsageDataSchema: TalonOneCouponUsageDataSchema,
    exposedUsageDataSchema: TalonOneCouponExposedUsageDataSchema,
    exposedUsageDataForExportSchema: TalonOneCouponExposedUsageDataForExportSchema,
    defaultMaxUsagesPerToken: null,
    requiresMerchantConnection: true,
    localizedConfig: false,
  };
